<template>
  <div class="TeamOffice">
    <Block404 v-if="show404" />
    <template v-else>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path: '/team'}">机构信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news">
        <div class="title">{{data.name}}主要职责</div>
        <div class="desc">
          <p>{{data.desc}}</p>
        </div>
        <div class="only_pc">
          <div class="tools">
            <div class="tools_item" @click="savePage">保存本页</div>
            <div class="tools_item" @click="printPage">打印本页</div>
            <div class="tools_item" @click="closePage">关闭窗口</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Block404 from "@/components/Block404.vue";
import teamData from "@/utils/teamData";

export default {
  name: "TeamOffice",
  components: {
    Block404
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      id: this.$route.params.id,
      show404: false,
      data: {}
    };
  },
  watch: {
    $route(to) {
      if (to.params.id && to.params.id != this.id) {
        this.id = to.params.id;
        this.show404 = false;
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      document.documentElement.scrollTop = 0;
      let current = null;
      teamData.office.forEach(item => {
        if (item.id == this.id) current = item;
      });
      if (current) {
        this.data = current;
      } else {
        this.show404 = true;
      }
    },
    savePage() {
      let data = document.getElementsByTagName("html")[0].outerHTML,
        urlObject = window.URL || window.webkitURL || window,
        exportBlob = new Blob([data]),
        saveLink = document.createElementNS(
          "http://www.w3.org/1999/xhtml",
          "a"
        ),
        ev = document.createEvent("MouseEvents");
      saveLink.href = urlObject.createObjectURL(exportBlob);
      saveLink.download = "news" + this.id + ".html";
      ev.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      saveLink.dispatchEvent(ev);
    },
    printPage() {
      window.print();
    },
    closePage() {
      window.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.TeamOffice {
  padding-top: 40px;
  padding-bottom: 60px;
  @include body_block;
  @media (max-width: $mob-screen) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .breadcrumb {
    margin-bottom: 20px;
    @media (max-width: $mob-screen) {
      margin-bottom: 8px;
    }
    @media print {
      display: none;
    }
    .el-breadcrumb {
      line-height: 28px;
      font-size: 20px;
      @media (max-width: $mob-screen) {
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
  .news {
    background: #fff;
    padding: 48px 140px;
    @media (max-width: 900px) {
      padding: 48px 50px;
    }
    @media (max-width: $mob-screen) {
      padding: 16px;
    }
    .title {
      line-height: 50px;
      font-size: 36px;
      font-weight: 600;
      text-align: center;
      color: $primary_blue;
      @media (max-width: $mob-screen) {
        line-height: 30px;
        font-size: 18px;
      }
    }
    .desc {
      margin-top: 12px;
      line-height: 36px;
      font-size: 20px;
      color: #242424;
      @media (max-width: $mob-screen) {
        margin-top: 16px;
        line-height: 20px;
        font-size: 14px;
      }
    }
    .source {
      margin-top: 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding-bottom: 40px;
      text-align: center;
      line-height: 22px;
      font-size: 16px;
      color: #888;
      @media (max-width: $mob-screen) {
        padding-bottom: 16px;
        line-height: 16px;
        font-size: 12px;
      }
    }
    .tools {
      margin-top: 40px;
      @include flex_center_center;
      .tools_item {
        width: 155px;
        line-height: 49px;
        background: #f5f6f9;
        text-align: center;
        margin: 0 20px;
        font-size: 16px;
        color: #000;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
@for $i from 2 to 6 {
  .page_theme_#{$i} {
    .TeamOffice {
      .news {
        background: nth($bg_color, $i);
        .title {
          color: nth($text_color, $i);
        }
        .desc {
          color: nth($text_color, $i);
        }
        .tools {
          .tools_item {
            background: nth($bg_color, $i);
            color: nth($text_color, $i);
            border: 1px solid nth($text_color, $i);
          }
        }
      }
    }
  }
}
</style>